<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="refreshChange"
      @on-load="onLoad">
      
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permissionList.delBtn"
          @click="handleDelete">
          批量删除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { getList, getDetail, add, update, remove } from "@/api/ad/channelAreaDaymax";
import { mapGetters } from "vuex";

export default {
  name: 'ChannelAreaDaymax',
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      selectionList: [],
      option: {
        height: 'auto',
        calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        dialogClickModal: false,
        labelWidth: 120,
        
        column: [
          {
            label: "ID",
            prop: "id",
            addDisplay: false,
            editDisplay: false,
            search: false,
            display: false
          },
          {
            label: "渠道ID",
            prop: "channelCid",
            search: true,
            rules: [{
              required: true,
              message: "请输入渠道ID",
              trigger: "blur"
            }]
          },
          {
            label: "渠道名称",
            prop: "channelName",
            search: true,
            rules: [{
              required: true,
              message: "请输入渠道名称",
              trigger: "blur"
            }]
          },
          {
            label: "地域ID",
            prop: "areaIds",
            type: "tree",
            // Assuming tree data should be loaded or it is just a text field
            // Since it says "multiple, separated by comma", maybe input or select?
            // Keeping as input for now unless area data source is known
            rules: [{
              required: true,
              message: "请输入地域ID",
              trigger: "blur"
            }]
          },
          {
            label: "地域名称",
            prop: "areaNames",
             rules: [{
              required: true,
              message: "请输入地域名称",
              trigger: "blur"
            }]
          },
          {
            label: "日频",
            prop: "daymax",
            type: "number",
            rules: [{
              required: true,
              message: "请输入日频",
              trigger: "blur"
            }]
          },
          {
            label: "间隔时间",
            prop: "intervalTime",
            type: "number",
            rules: [{
              required: true,
              message: "请输入间隔时间",
              trigger: "blur"
            }]
          },
          {
            label: "备注",
            prop: "descr",
            type: "textarea",
            span: 24
          },
          {
            label: "添加人",
            prop: "addUser",
            addDisplay: false,
            editDisplay: false
          },
          {
            label: "添加时间",
            prop: "addTime",
            addDisplay: false,
            editDisplay: false,
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss"
          },
           {
            label: "修改人",
            prop: "modifyUser",
            addDisplay: false,
            editDisplay: false
          },
          {
            label: "修改时间",
            prop: "modifyTime",
            addDisplay: false,
            editDisplay: false,
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss"
          }
        ]
      },
      data: []
    };
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.channelAreaDaymax_add, false),
        viewBtn: this.vaildData(this.permission.channelAreaDaymax_view, false),
        delBtn: this.vaildData(this.permission.channelAreaDaymax_delete, false),
        editBtn: this.vaildData(this.permission.channelAreaDaymax_edit, false)
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach(ele => {
        ids.push(ele.id);
      });
      return ids;
    }
  },
  mounted() {
    this.onLoad(this.page);
  },
  methods: {
    rowSave(row, loading, done) {
      add(row).then(res => {
         if(res.data.code === 200) {
            this.onLoad(this.page);
            this.$message.success('新增成功');
            loading();
         } else {
             this.$message.error(res.data.msg);
             done();
         }
      }, error => {
        done();
        console.log(error);
      });
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(res => {
         if(res.data.code === 200) {
            this.onLoad(this.page);
            this.$message.success('修改成功');
            loading();
         } else {
             this.$message.error(res.data.msg);
             done();
         }
      }, error => {
         done();
         console.log(error);
      });
    },
    rowDel(row) {
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          return remove([row.id]);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }
      this.$confirm("确定要删除选中的数据吗?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          return remove(this.ids);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "批量删除成功!"
          });
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (["edit", "view"].includes(type)) {
        getDetail(this.form.id).then(res => {
          this.form = res.data.data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad(this.page);
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, this.query);
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad(page, params = {}) {
      this.loading = true;
      getList(Object.assign({
        current: page.currentPage,
        size: page.pageSize
      }, params, this.query)).then(res => {
        const data = res.data.data;
        this.page.total = data.total;
        this.data = data.records;
        this.loading = false;
        this.selectionClear();
      });
    }
  }
};
</script>

<style>
</style>
